Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.httpGetMethod = "GET";
exports.httpPostMethod = "POST";
exports.httpDeleteMethod = "DELETE";

exports.contactUsApiContentType = "application/json";
exports.getContactUsAPiEndPoint = "contact_us/contacts";

exports.errorTitle = "Error";
exports.errorAllFieldsAreMandatory = "All fields are mandatory.";
exports.errorEmailNotValid = "Email not valid.";
exports.phoneNumberError = "Phone number not valid"

exports.nameTitle = "Name";
exports.emailTitle = "Email";
exports.numberTitle = "Phone number";
exports.commentsTitle = "Comments";

exports.namePlaceHolder = "Enter Your Name";
exports.emailPlaceHolder = "Enter Your Email";
exports.numberPlaceHolder = "Enter Phone number";
exports.commentsPlaceHolder = "Enter Comments";

exports.labelTitleText = "contactus";
exports.labelBodyText = "contactus Body";

exports.btnExampleTitle = "CLICK ME";
exports.sendMsgBtnText = "Send Message";

exports.sendContactUsApiEndpoint = "bx_block_contact_us/contacts"
exports.contactUsImageApiEndpoint = "bx_block_contact_us/contact_us_image"

exports.ALLOWED_DOCUMENT_TYPES = ["pdf", "doc", "docx"]
exports.ALLOWED_FILE_EXTENSIONS = ["png", "jpg", "jpeg", "gif", "pdf", "doc", "docx"]

exports.successfulContactUsText = "Thank you for contacting us!\nWe will get back to you shortly."
exports.maxSizeFileErrorText = "Max file size allowed is 10MB"
exports.invalidFileTypeErrorText = "Only images (PNG, JPEG, GIF, JPG) and documents (PDF, DOC, DOCX) are allowed"
// Customizable Area End